import { useContext, createContext } from 'react';

export const BreadCrumbsContext = createContext(null);

export function useBreadCrumbsContext() {
  return useContext(BreadCrumbsContext);
}
